import { FC } from "react";
import ModalComponent from "../../shared/base-components/Modal";

import { Col, Row, Table } from "reactstrap";
import {
  BuySellDevicePartDetailModalProps,
  paymentFormatter,
} from "./BuySell.constants";
import { formatDateString } from "../../shared/utils/formatText";

const BuySellDevicePartDetailModal: FC<BuySellDevicePartDetailModalProps> = ({
  deviceData,
  isModalOpen,
  toggle,
}) => {
  return (
    <ModalComponent
      header={"Malzeme Bilgileri"}
      description={""}
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Row>
        <Col lg={12}>
          <div className="border rounded">
            <div className="table-responsive">
              <Table className="table-nowrap align-middle mb-0">
                <tbody>
                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Malzeme adı:"}</h5>

                    <td className="text-start">
                      {deviceData?.device_part?.name}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Miktar:"}</h5>

                    <td style={{ whiteSpace: "normal" }} className="text-start">
                      {deviceData?.amount}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Toplam Fiyat:"}</h5>

                    <td className="text-start">{deviceData?.total_price}</td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"İşlem:"}</h5>

                    <td className="text-start">
                      {deviceData?.content_type === 1 ? "Alış" : "Satış"}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Tarih:"}</h5>

                    <td className="text-start">
                      {formatDateString(deviceData?.date)}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Not:"}</h5>

                    <td className="text-start">{deviceData?.note}</td>
                  </tr>

                  <tr key={"Ödeme Tipi"}>
                    <h5 className="font-size-15 mb-1">{"Ödeme Tipi:"}</h5>

                    <td className="text-start">
                      {paymentFormatter(deviceData?.payment_type)}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </Col>
      </Row>
    </ModalComponent>
  );
};

export default BuySellDevicePartDetailModal;
